import type { Technique } from '../types';
import { SPACE_COLONIZATION_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, toSVG, type SpaceColonizationState } from './render';

export const spaceColonization: Technique<SpaceColonizationState> = {
  id: 'space-colonization',
  name: 'Space Colonization',
  category: 'growth',
  description: 'Adernetz wächst zu verteilten Attraktorpunkten und umspielt dabei die Buchstaben.',
  params: SPACE_COLONIZATION_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  toSVG,
  elementCount,
};
